import master from './generated/organizations';

/**
 * organizations の判定を行うさいに groups が紐づいていて欲しいケースが多いため紐づけた後に export する
 * @param organization
 */
export function defineOrganizationWithGroup<
  O extends { name: N; roles: readonly ROLE[] },
  N extends string,
  ROLE extends { name: string; displayName: string },
>(organization: O & { name: N; roles: readonly ROLE[] }) {
  return {
    ...organization,
    groups: organization.roles.map((role) => {
      return {
        name: `${organization.name}:${role.name}`,
        displayName: role.displayName,
      } as ROLE extends { name: infer ROLE_NAME extends string; displayName: infer DISPLAY_NAME extends string }
        ? { name: `${N}:${ROLE_NAME}`; displayName: DISPLAY_NAME }
        : never;
    }),
  };
}

const NfdwEdu_ZenUniversity = defineOrganizationWithGroup(master.NfdwEdu_ZenUniversity);
const NfdwEdu = defineOrganizationWithGroup(master.NfdwEdu);
const KadokawaGroup_Dwango = defineOrganizationWithGroup(master.KadokawaGroup_Dwango);
const KddwEduHighschool_NHighschool = defineOrganizationWithGroup(master.KddwEdu_NHighschool);
const KddwEduHighschool_SHighschool = defineOrganizationWithGroup(master.KddwEdu_SHighschool);
const KddwEduHighschool_RHighschool = defineOrganizationWithGroup(master.KddwEdu_RHighschool);
const CustomerService = defineOrganizationWithGroup(master.CustomerService);

export const organizations = {
  NfdwEdu_ZenUniversity,
  NfdwEdu,
  KadokawaGroup_Dwango,
  KddwEduHighschool_NHighschool,
  KddwEduHighschool_SHighschool,
  KddwEduHighschool_RHighschool,
  CustomerService,
};
